<section class="site-hero-banner-main-wrap">
    <div class="container">
        <div class="site-hero-banner-main hero-container">
            <div id="carouselExample" class="carousel slide">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="0" class="active"
                        aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="1"
                        aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="2"
                        aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="3"
                        aria-label="Slide 4"></button>
                </div>

                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <div class="site-hero-banner-main-slide">
                            <div class="site-hero-banner-main-content">
                                <h1 class="site-heading-h1">
                                    Start Your Investigation with
                                    a Deep Social Media Report.
                                    Analyst verified
                                    <span>- Only $59.95</span>
                                </h1>
                                <div class="site-hero-banner-main-info">
                                    <div class="site-hero-banner-report">
                                        <img src="images/svg/check-icon.svg" alt="check icon">
                                        <p class="site-heading-h5">100% Private and Confidential</p>
                                    </div>
                                </div>
                                <div class="site-common-btn" routerLink="/order-deep-report/new">
                                    <a class="site-btn">Order Report Here</a>
                                </div>
                            </div>
                            <div class="site-hero-banner-main-img">
                                <img src="images/svg/in-depth-social-media-report.svg" alt="report-analysis Image">
                            </div>
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="site-hero-banner-main-slide">
                            <div class="site-hero-banner-main-content">
                                <h1 class="site-heading-h1">
                                    Intelligence Reports for Evidence
                                    of Criminal Wrongdoing, Brand
                                    Protection, Asset Tracing, etc
                                </h1>
                                <div class="site-hero-banner-main-info">
                                    <div class="site-hero-banner-report">
                                        <img src="images/svg/check-icon.svg" alt="check icon">
                                        <p class="site-heading-h5">100% Private and Confidential</p>
                                    </div>
                                </div>
                                <div class="site-common-btn" routerLink="/contact-us">
                                    <a class="site-btn">Request a Quote Here</a>
                                </div>
                            </div>
                            <div class="site-hero-banner-main-img">
                                <img src="images/svg/meeting.svg" alt="meeting Image">
                            </div>
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="site-hero-banner-main-slide">
                            <div class="site-hero-banner-main-content">
                                <h1 class="site-heading-h1">
                                    Jury Selection Vetting
                                    Reports for U.S. Attorneys
                                    <span>Only $120 per Juror </span>
                                </h1>
                                <div class="site-hero-banner-main-info">
                                    <div class="site-hero-banner-report">
                                        <img src="images/svg/check-icon.svg" alt="check icon">
                                        <p class="site-heading-h5">100% Private and Confidential</p>
                                    </div>
                                </div>
                                <div class="site-common-btn" routerLink="/order-juror-report/new">
                                    <a class="site-btn">Order Report Here</a>
                                </div>
                            </div>
                            <div class="site-hero-banner-main-img">
                                <img src="images/svg/evalution-banner.svg" alt="evalution Image">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="site-hero-banner-main-slide">
                            <div class="site-hero-banner-main-content">
                                <h1 class="site-heading-h1">
                                    Pre-Visa / Immigration
                                    Background Checks.
                                    Know what they will find
                                    out about you before your
                                    application.
                                    <span>ONLY $150</span>
                                </h1>
                                <div class="site-hero-banner-main-info">
                                    <div class="site-hero-banner-report">
                                        <img src="images/svg/check-icon.svg" alt="check icon">
                                        <p class="site-heading-h5">100% Private and Confidential</p>
                                    </div>
                                </div>
                                <div class="site-common-btn" routerLink="/contact-us">
                                    <a class="site-btn">Order Report Here</a>
                                </div>
                            </div>
                            <div class="site-hero-banner-main-img">
                                <img src="images/svg/pre-visa-immigration-background-check.svg" alt="Approved Image">
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <div class="site-hero-contact-details">
            <div class="site-hero-contact-detail" (click)="crossComponentService.openCallModal()">
                <div class="site-hero-contact-detail-img">
                    <img src="images/svg/headphone.svg" alt="Headphone Image">
                </div>
                <div class="site-hero-contact-detail-content">
                    <p class="site-text-p">Talk to An ANALYST</p>
                    <h5><a href="#">800-808-0862</a></h5>
                </div>
            </div>
            <div class="site-hero-report">
                <div class="site-hero-info">
                    <p>Be Smart | Save Time | Save Money</p>
                </div>
                <div class="site-common-btn" routerLink="/order-deep-report/new">
                    <a class="site-btn">Order Report Here</a>
                </div>
            </div>
        </div>
    </div>

</section>

@if(crossComponentService.callModal()) {
<app-call-modal />
}
